window.addEventListener("onEmbeddedMessagingReady", (event) => {
  console.log("Received the onEmbeddedMessagingConversationStarted event…");
  console.log("Event detail: ", event.detail);
  
      embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields({
        "Country": {
          "value": "France",
        },
        "Language": {
          "value": "France",
          "isEditableByEndUser": true
        }
      });
});
window.addEventListener("onEmbeddedMessagingWindowClosed", (event) => {
  sendMessage();
});
function sendMessage() {
  embeddedservice_bootstrap.utilAPI.sendTextMessage("Customer already left");
}
function initEmbeddedMessaging() {
  try {
    embeddedservice_bootstrap.settings.language = 'fr'; // For example, enter 'en' or 'en-US'

    embeddedservice_bootstrap.init(
      '00D7Q0000090wbR',
      'FRMessaging',
      'https://roborockeu2.my.site.com/ESWFRMessaging1769753858438',
      {
        scrt2URL: 'https://roborockeu2.my.salesforce-scrt.com'
      }
    );
  } catch (err) {
    console.error("Error loading Embedded Messaging: ", err);
  }
};
function fixEmbeddedMessagingPosition() {
  const iframe = document.querySelector("iframe.embeddedMessagingFrame");

  if (iframe) {
    iframe.style.setProperty("z-index", "2147483647", "important");
  }
}

function addChatExpertMessage() {
  const embeddedMessagingIconChat = document.querySelector(
    ".embeddedMessagingIconChat"
  );

  if (
    embeddedMessagingIconChat &&
    !embeddedMessagingIconChat.nextElementSibling?.classList.contains("message")
  ) {
    const messageSpan = document.createElement("p");
    messageSpan.className = "message";
    messageSpan.textContent = "Chat with an expert";
    embeddedMessagingIconChat.insertAdjacentElement("afterend", messageSpan);
  }
}

// 观察DOM变化，当聊天图标加载后添加文本
const embeddedMsgObserver = new MutationObserver((mutations) => {
  addChatExpertMessage();
});

// 开始观察
if (document.body) {
  embeddedMsgObserver.observe(document.body, { childList: true, subtree: true });
}

// 也尝试在页面加载后延迟执行
setTimeout(addChatExpertMessage, 1000);
setTimeout(addChatExpertMessage, 2000);
